import { Component, OnInit } from '@angular/core';
import { PermissionService } from 'src/app/modules/wino-shared/services/permission.service';

@Component({
  selector: 'app-title-bar',
  templateUrl: './title-bar.component.html',
  styleUrls: ['./title-bar.component.scss']
})
export class TitleBarComponent implements OnInit {

    public pageTitle: string = "Titolo della pagina";
    public offcanvasNeeded: boolean = false;
    public imageName: string = "";
  
    constructor(private permissionService: PermissionService) { }

    ngOnInit(): void {
        this.permissionService.titleBarData.subscribe(data => {
            this.pageTitle = data.title;
            this.offcanvasNeeded = data.offcanvas;
            this.imageName = data.imageName;
        });
    }
}